import { create } from "zustand";
import * as FormHelper from "@/lib/form";
import {
  ContractSortOptions,
  ContractFilterOptions,
} from "@/lib/api/generalContract";
import {
  FilterFormSchema,
  SortFormSchema,
} from "@/lib/schemas/generalContract";
import { BaseFormSchema, DownloadRecentFormSchema } from "./GeneralContractSchemas";

export const useSortFilterState = create((set) => ({
  sorting: {
    created_at: "desc",
  } as ContractSortOptions,
  filters: { staged_for_review: false } as ContractFilterOptions,
  setSortState: (newState: ContractSortOptions) =>
    set((state: any) => ({ sorting: newState })),
  setFilterState: (newState: ContractFilterOptions) =>
    set((state: any) => ({
      filters: {
        ...newState,
        staged_for_review: false,
      },
    })),
  clearAll: () => set((state: any) => ({ filters: {}, sorting: {} })),
}));

export const createState = FormHelper.generateBaseState({
  schemas: [BaseFormSchema],
  baseSchema: BaseFormSchema,
});

export const updateState = FormHelper.generateBaseState({
  schemas: [BaseFormSchema],
  baseSchema: BaseFormSchema,
});

export const sortOptionsState = FormHelper.generateBaseState({
  schemas: [SortFormSchema],
  baseSchema: SortFormSchema,
  overrideValues: { created_at: "desc" },
});

export const filterOptionsState = FormHelper.generateBaseState({
  schemas: [FilterFormSchema],
  baseSchema: FilterFormSchema,
});

export const downloadImportState = FormHelper.generateBaseState({
  schemas: [DownloadRecentFormSchema],
  baseSchema: DownloadRecentFormSchema,
});

export const previewState = FormHelper.generateBaseState({
  schemas: [BaseFormSchema],
  baseSchema: BaseFormSchema,
});

